import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

function AxlAutocomplete(props) {
  const {
    options,
    handleChange,
    size = 'small',
    variant = 'outlined',
    isFreeSolo = false,
    label,
    style,
    className,
    isMultiple = false,
    limitTags,
    value,
    getOptionLabel,
    placeholder,
    required,
    error,
    helperText,
    inputProps,
    ...otherProps
  } = props;
  return (
    <Autocomplete
      freeSolo={isFreeSolo}
      options={options}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          placeholder={value?.length > 0 ? '' : placeholder}
          required={required}
          error={error}
          helperText={error && helperText}
          slotProps={{
            ...params.slotProps,

            htmlInput: {
              ...params.slotProps.htmlInput,
              ...inputProps,
            },
          }}
        />
      )}
      size={size}
      onChange={handleChange}
      style={style}
      className={className}
      multiple={isMultiple}
      limitTags={limitTags}
      value={value}
      getOptionLabel={getOptionLabel}
      {...otherProps}
    />
  );
}

export default AxlAutocomplete;
